import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PptxEmbedViewer from './PptxEmbedViewer.jsx';
import SlideDeckViewer, { buildSlidesFromModules } from './SlideDeckViewer.jsx';
import { PROFESSIONAL_DEVELOPMENT_PATH } from '../../constants/professionalDevelopment.js';

function LessonPlayer({ resource }) {
  const modules = resource.modules?.length ? resource.modules : [];
  const slides = useMemo(() => buildSlidesFromModules(modules), [modules]);
  const hasDeck = Boolean(resource.viewUrl || resource.pptxKey);

  if (!modules.length && !hasDeck) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
        <div className="max-w-md text-center">
          <h1 className="text-2xl font-bold text-[#1a4a1a] mb-3">{resource.title}</h1>
          <p className="text-slate-600 mb-6 leading-relaxed">
            No lesson content is linked to this package yet.
          </p>
          <Link to={PROFESSIONAL_DEVELOPMENT_PATH} className="text-emerald-700 font-medium hover:underline">
            Back to Professional Development
          </Link>
        </div>
      </div>
    );
  }

  if (slides.length > 0) {
    return <SlideDeckViewer resource={resource} slides={slides} />;
  }

  if (hasDeck) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-slate-50 to-emerald-50/30">
        <div className="bg-white border-b border-slate-200 sticky top-0 z-30">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <Link
              to={PROFESSIONAL_DEVELOPMENT_PATH}
              className="inline-flex items-center gap-2 text-sm text-emerald-800 hover:text-[#1a4a1a] font-medium mb-3"
            >
              <ArrowLeft className="w-4 h-4" />
              Professional Development
            </Link>
            <h1 className="text-xl md:text-2xl font-bold text-[#1a4a1a]">{resource.title}</h1>
            <p className="text-sm text-slate-500">{resource.subtitle}</p>
          </div>
        </div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6 md:p-10">
            <PptxEmbedViewer
              viewUrl={resource.viewUrl}
              title={resource.title}
              fileName={resource.pptxFileName}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-bold text-[#1a4a1a] mb-3">{resource.title}</h1>
        <p className="text-slate-600 mb-6 leading-relaxed">
          Slide images are not linked to this package yet.
        </p>
        <Link to={PROFESSIONAL_DEVELOPMENT_PATH} className="text-emerald-700 font-medium hover:underline">
          Back to Professional Development
        </Link>
      </div>
    </div>
  );
}

export default LessonPlayer;
